import { mergeStyles, TextField } from '@fluentui/react';
import { useEffect, useState } from 'react';

import { emailRegex } from '..';
import { store } from '../../../../App/store';
import { prettyString, trStrToEnLower } from '../../../../utils/common';
import { actions } from '../../slice';

type Props = {
  label: string;
  variable: string;
  defaultValue?: string;
  isMultiline?: boolean;
  email?: boolean;
  disabled?: boolean;
  maxLength?: number;
  onChange?: (value: string) => any;
};

export default (props: Props) => {
  const storeValue: string =
    store.getState().accounts.accountVariables[props.variable];
  const [value, setValue] = useState(
    storeValue !== undefined ? storeValue : props.defaultValue
  );
  const [error, setError] = useState<string>();

  if (!storeValue && props.defaultValue)
    actions.setAccountVariable([props.variable, props.defaultValue]);

  const transform = (nv: string) => {
    if (props.email) {
      return trStrToEnLower(nv).replace(/\s/g, "");
    } else {
      return prettyString(nv);
    }
  };

  useEffect(() => {
    if (value !== undefined) {
      setValue(transform(value));
    }

    props.onChange?.(value ? transform(value) : "");
  }, []);

  return (
    <TextField
      label={props.label}
      disabled={props.disabled}
      maxLength={props.maxLength}
      value={value}
      className={inputStyles}
      multiline={props.isMultiline}
      errorMessage={error}
      onChange={(_, nv) => {
        if (typeof nv !== "string") {
          nv = "";
        }

        props.onChange?.(transform(nv));
        setValue(nv);
      }}
      onFocus={() => error && setError(undefined)}
      onBlur={() => {
        if (props.email && value && !value.match(emailRegex)) {
          setError("E-Mail adresi hatalı");
        }

        if (value !== undefined) {
          setValue(transform(value));
        }

        actions.setAccountVariable([props.variable, value]);
      }}
    />
  );
};

const inputStyles = mergeStyles({
  width: "100%",
});
